/** Flash `el` with `className` (an animation in styles.css), restarted each time, even mid-flash: Show pressed again and again. */
export function flash(el: HTMLElement, className: string) {
    el.classList.remove(className);
    // Reading its size makes the browser see it without the class, so adding it again restarts the animation.
    void el.offsetWidth;
    el.classList.add(className);
}
